function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M134.503 0H5.495C2.46641 0 0 2.46641 0 5.49746V134.505C0 137.534 2.46641 140 5.495 140H134.503C137.534 140 140 137.534 140 134.505V5.49746C140 2.46641 137.534 0 134.503 0ZM135.333 134.505C135.333 134.96 134.96 135.333 134.503 135.333H5.495C5.04 135.333 4.66676 134.96 4.66676 134.505V5.49746C4.66676 5.04 5.04 4.66676 5.495 4.66676H134.503C134.96 4.66676 135.333 5.04 135.333 5.49746V134.505Z",
  fill: "#3F95BC"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M126 11.667H14.0002C12.7123 11.667 11.667 12.7123 11.667 14.0002V51.3335C11.667 52.6214 12.7123 53.6667 14.0002 53.6667H126C127.288 53.6667 128.333 52.6214 128.333 51.3335V14.0002C128.333 12.7123 127.288 11.667 126 11.667ZM123.667 49.0002H16.3335V16.3335H123.667V49.0002H123.667Z",
  fill: "#3F95BC"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M39.0859 58.333H16.917C14.0213 58.333 11.667 60.6873 11.667 63.583V85.7498C11.667 88.6455 14.0213 90.9998 16.917 90.9998H39.0837C41.9794 90.9998 44.3337 88.6455 44.3359 85.7522V63.5833C44.3359 60.6873 41.9792 58.333 39.0859 58.333ZM39.6692 85.7498C39.6692 86.0719 39.4078 86.333 39.0859 86.333H16.917C16.5949 86.333 16.3337 86.0716 16.3337 85.752V63.583C16.3337 63.2609 16.5952 62.9998 16.917 62.9998H39.0859C39.408 62.9998 39.6692 63.2612 39.6692 63.583V85.7498Z",
  fill: "#3F95BC"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M39.0859 95.667H16.917C14.0213 95.667 11.667 98.0213 11.667 100.917V123.084C11.667 125.979 14.0213 128.334 16.917 128.334H39.0837C41.9794 128.334 44.3337 125.979 44.3359 123.086V100.917C44.3359 98.0213 41.9792 95.667 39.0859 95.667ZM39.6692 123.083C39.6692 123.406 39.4078 123.667 39.0859 123.667H16.917C16.5949 123.667 16.3337 123.405 16.3337 123.086V100.917C16.3337 100.595 16.5952 100.333 16.917 100.333H39.0859C39.408 100.333 39.6692 100.595 39.6692 100.917V123.083Z",
  fill: "#3F95BC"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M78.7519 95.667H56.583C53.6873 95.667 51.333 98.0237 51.333 100.917V123.084C51.333 125.979 53.6898 128.334 56.583 128.334H78.7495C81.6452 128.334 83.9995 125.979 84.002 123.086V100.917C84.002 98.0213 81.6452 95.667 78.7519 95.667ZM79.3352 123.086C79.3352 123.408 79.0738 123.669 78.7519 123.669H56.583C56.2609 123.669 55.9998 123.408 55.9998 123.086V100.917C55.9998 100.595 56.2612 100.334 56.583 100.334H78.7519C79.0741 100.334 79.3352 100.595 79.3352 100.917V123.086Z",
  fill: "#3F95BC"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M78.7519 58.333H56.583C53.6873 58.333 51.333 60.6898 51.333 63.583V85.7498C51.333 88.6455 53.6898 90.9998 56.583 90.9998H78.7495C81.6452 90.9998 83.9995 88.6455 84.002 85.7522V63.5833C84.002 60.6873 81.6452 58.333 78.7519 58.333ZM79.3352 85.7522C79.3352 86.0744 79.0738 86.3355 78.7519 86.3355H56.583C56.2609 86.3355 55.9998 86.0741 55.9998 85.7522V63.5833C55.9998 63.2612 56.2612 63 56.583 63H78.7519C79.0741 63 79.3352 63.2614 79.3352 63.5833V85.7522Z",
  fill: "#3F95BC"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M123.083 58.333H96.25C93.3543 58.333 91 60.6898 91 63.583V123.083C91 125.979 93.3568 128.333 96.25 128.333H123.083C125.979 128.333 128.333 125.979 128.333 123.083V63.583C128.333 60.6873 125.977 58.333 123.083 58.333ZM123.667 123.083C123.667 123.405 123.405 123.666 123.084 123.666H96.25C95.9279 123.666 95.6668 123.405 95.6668 123.083V63.583C95.6668 63.2609 95.9282 62.9998 96.25 62.9998H123.083C123.405 62.9998 123.666 63.2612 123.666 63.583V123.083H123.667Z",
  fill: "#3F95BC"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M66.08 21H59.92C57.7593 21 56 22.7593 56 24.92V40.4132C56 42.5739 57.7593 44.3332 59.92 44.3332H66.08C68.2407 44.3332 70 42.5739 70 40.4132V24.92C70 22.7593 68.2407 21 66.08 21ZM65.3332 39.6668H60.6665V25.6668H65.3332V39.6668Z",
  fill: "#3F95BC"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M89.413 21H83.253C81.0923 21 79.333 22.7593 79.333 24.92V40.4132C79.333 42.5739 81.0923 44.3332 83.253 44.3332H89.413C91.5737 44.3332 93.333 42.5739 93.333 40.4132V24.92C93.333 22.7593 91.5737 21 89.413 21ZM88.6665 39.6668H83.9998V25.6668H88.6665V39.6668Z",
  fill: "#3F95BC"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M108.08 21H101.92C99.7593 21 98 22.7593 98 24.92V40.4132C98 42.5739 99.7593 44.3332 101.92 44.3332H108.08C110.241 44.3332 112 42.5739 112 40.4132V24.92C112 22.7593 110.241 21 108.08 21ZM107.333 39.6668H102.666V25.6668H107.333V39.6668Z",
  fill: "#3F95BC"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M116.667 86.333H102.667C101.379 86.333 100.334 87.3784 100.334 88.6662C100.334 89.9541 101.379 90.9995 102.667 90.9995H116.667C117.955 90.9995 119 89.9541 119 88.6662C119 87.3784 117.955 86.333 116.667 86.333Z",
  fill: "#3F95BC"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M32.6668 72.333H23.3332C22.0454 72.333 21 73.3784 21 74.6663C21 75.9541 22.0454 76.9995 23.3332 76.9995H32.6665C33.9544 76.9995 34.9997 75.9541 34.9997 74.6663C35 73.3784 33.9546 72.333 32.6668 72.333Z",
  fill: "#3F95BC"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M32.6668 109.667H23.3332C22.0454 109.667 21 110.712 21 112C21 113.288 22.0454 114.333 23.3332 114.333H32.6665C33.9544 114.333 34.9997 113.288 34.9997 112C34.9997 110.712 33.9546 109.667 32.6668 109.667Z",
  fill: "#3F95BC"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M116.667 95.667H102.667C101.379 95.667 100.334 96.7123 100.334 98.0002C100.334 99.2881 101.379 100.333 102.667 100.333H116.667C117.955 100.333 119 99.2881 119 98.0002C119 96.7123 117.955 95.667 116.667 95.667Z",
  fill: "#3F95BC"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M28.0002 67.667C26.7123 67.667 25.667 68.7123 25.667 70.0002V79.3335C25.667 80.6214 26.7123 81.6667 28.0002 81.6667C29.2881 81.6667 30.3335 80.6214 30.3335 79.3335V70.0002C30.3335 68.7123 29.2881 67.667 28.0002 67.667Z",
  fill: "#3F95BC"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M73.9829 68.3504C73.0704 67.4379 71.5958 67.4379 70.6836 68.3504L61.3504 77.6836C60.4379 78.5961 60.4379 80.0707 61.3504 80.9829C61.8054 81.4379 62.4028 81.6665 63 81.6665C63.5975 81.6665 64.1947 81.4379 64.6497 80.9829L73.9829 71.6497C74.8954 70.7375 74.8954 69.2625 73.9829 68.3504Z",
  fill: "#3F95BC"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M73.9829 77.6836L64.6497 68.3504C63.7375 67.4379 62.2625 67.4379 61.3504 68.3504C60.4379 69.2625 60.4379 70.7375 61.3504 71.6497L70.6836 80.9829C71.1386 81.4379 71.7361 81.6665 72.3333 81.6665C72.9307 81.6665 73.5279 81.4379 73.9829 80.9829C74.8954 80.0707 74.8954 78.5961 73.9829 77.6836Z",
  fill: "#3F95BC"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M71.0452 105.245C69.888 104.668 68.4902 105.137 67.9138 106.288L63.247 115.623C62.6706 116.776 63.1374 118.178 64.2899 118.755C64.6235 118.92 64.9806 119 65.3306 119C66.187 119 67.0106 118.526 67.4213 117.712L72.0881 108.376C72.6645 107.223 72.1977 105.821 71.0452 105.245Z",
  fill: "#3F95BC"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M74.6662 37.333C73.3784 37.333 72.333 38.3784 72.333 39.6662V41.9995C72.333 43.2874 73.3784 44.3327 74.6662 44.3327C75.9541 44.3327 76.9995 43.2874 76.9995 41.9995V39.6662C76.9995 38.3784 75.9541 37.333 74.6662 37.333Z",
  fill: "#3F95BC"
});

function SvgNumbersOperationsBaseTen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumbersOperationsBaseTen);
export default __webpack_public_path__ + "static/media/numbers-operations-base-ten.8b55e600.svg";
export { ForwardRef as ReactComponent };